import { api } from '../lib/api-client';

// Authentication API
export const authApi = {
  // Ghana card verification
  verifyGhanaCard: (ghanaCardNumber) => {
    const formData = new FormData();
    formData.append('ghana_card_number', ghanaCardNumber);
    return api.post('/self-service/verify-ghanacard', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  // Create account after Ghana card verification
  createAccount: (data) => {
    const formData = new FormData();
    formData.append('verification_token', data.verification_token);
    formData.append('email', data.email);
    formData.append('phone', data.phone);
    formData.append('password', data.password);
    formData.append('c_password', data.c_password);
    return api.post('/self-service/create-account', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  // OTP verification
  verifyOtp: (data) => {
    const formData = new FormData();
    // Accept phone, email, or otp_ref for verification
    if (data.otp_ref) {
      formData.append('otp_ref', data.otp_ref);
    } else if (data.phone) {
      formData.append('phone', data.phone);
    } else if (data.email) {
      formData.append('email', data.email);
    }
    formData.append('otp', data.otp);
    
    // Let axios set Content-Type automatically for FormData
    return api.post('/self-service/verify-otp', formData);
  },

  // OTP verification for password reset
  verifyResetOtp: (data) => {
    const formData = new FormData();
    // Support both otp_ref (new) and email_or_phone (legacy)
    if (data.otp_ref) {
      formData.append('otp_ref', data.otp_ref);
    } else if (data.email_or_phone) {
      formData.append('email_or_phone', data.email_or_phone);
    }
    formData.append('otp', data.otp);
    // Let axios set Content-Type automatically for FormData
    return api.post('/self-service/verify-reset-otp', formData);
  },

  // Login (Email Address or Phone Number)
  login: (credentials) => {
    const formData = new FormData();
    formData.append('email_or_phone', credentials.email_or_phone);
    formData.append('password', credentials.password);
    return api.post('/self-service/login', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
    
  register: (userData) => 
    api.post('register', userData),
    
  verifyEmail: (data) => 
    api.post('verify-email', data),
    
  // (Removed old verifyOtp, now handled by new self-service/verify-otp above)
    
  createPassword: (data) => 
    api.post('create-password', data),
    
  forgotPassword: ({ email_or_phone }) => {
    console.log('forgotPassword called with:', email_or_phone);
    const formData = new FormData();
    formData.append('email_or_phone', email_or_phone);
    console.log('FormData created, posting to self-service/forgot-password');
    // Let axios set Content-Type automatically for FormData
    return api.post('self-service/forgot-password', formData).then(response => {
      console.log('forgotPassword API response:', response);
      return response;
    }).catch(error => {
      console.log('forgotPassword API error:', error);
      throw error;
    });
  },
    
  resetPassword: (data, token) => {
    const config = token ? {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    } : {};
    return api.post('reset-password', data, config);
  },
    
  refreshToken: (tokenValue) => 
    api.post('token/refresh', { tokenValue }),
    
  resendVerification: (email) => 
    api.post('resend-verification', { email }),
    
  logout: () => 
    api.post('logout'),
    
  getProfile: () => 
    api.get('profile'),
    
  updateProfile: (data) => 
    api.put('profile', data),
    
  changePassword: (data) => 
    api.post('change-password', data),

  // Resend OTP - supports both otp_ref and phone/email in FormData body
  resendOtp: (identifier) => {
    const formData = new FormData();
    
    // Check if identifier looks like a UUID (otp_ref) or phone number/email
    const isOtpRef = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(identifier);
    
    if (isOtpRef) {
      formData.append('otp_ref', identifier);
    } else {
      // For phone numbers (and emails), use phone parameter
      formData.append('phone', identifier);
    }
    
    return api.post('/self-service/resend-otp', formData);
  },
  // Delete account
  deleteAccount: () => api.delete('delete-account'),
};
